import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @atlaskit/design-system/no-nested-styles */
/** @jsx jsx */
import { PureComponent } from 'react';
import { css, jsx } from '@emotion/react';
import { spacing } from './constants';
import { ANIMATION_EASE_OUT, LINEAR_TRANSITION_SPEED, TRANSITION_SPEED, varSpacing } from './internal/constants';
import Link from './internal/link';
import Stage from './internal/stage';
var containerStyles = css({
  display: 'grid',
  width: '100%',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  margin: '0 auto',
  padding: "var(--ds-space-0, 0px)",
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  gap: "var(".concat(varSpacing, ")"),
  listStyleType: 'none',
  '&&': {
    marginBlockStart: "var(--ds-space-500, 40px)"
  }
});
var ProgressTracker = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressTracker, _PureComponent);
  var _super = _createSuper(ProgressTracker);
  function ProgressTracker() {
    var _this;
    _classCallCheck(this, ProgressTracker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      prevStages: _this.props.items.map(function (stage) {
        return _objectSpread(_objectSpread({}, stage), {}, {
          percentageComplete: 0
        });
      })
    });
    return _this;
  }
  _createClass(ProgressTracker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var prevStages = nextProps.items.map(function (stage) {
        var oldStage = _this2.props.items.find(function (st) {
          return st.id === stage.id;
        });
        return oldStage !== undefined ? oldStage : stage;
      });
      this.setState({
        prevStages: prevStages
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
        _listInlineStyles;
      var _this$props = this.props,
        testId = _this$props.testId,
        label = _this$props.label;
      var progressChanges = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete !== _this3.state.prevStages[index].percentageComplete;
      }).length;
      var totalStepsForward = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete > _this3.state.prevStages[index].percentageComplete;
      }).length;
      var totalStepsBack = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete < _this3.state.prevStages[index].percentageComplete;
      }).length;
      var stepsForward = totalStepsForward;
      var stepsBack = totalStepsBack;
      var items = this.props.items.map(function (stage, index) {
        var transitionSpeed = 0;
        var transitionDelay = 0;
        var transitionEasing = progressChanges > 1 ? 'linear' : ANIMATION_EASE_OUT;
        if (_this3.props.animated) {
          transitionSpeed = progressChanges > 1 ? LINEAR_TRANSITION_SPEED : TRANSITION_SPEED;
          if (stage.percentageComplete < _this3.state.prevStages[index].percentageComplete) {
            /**
             * Load each transition sequentially in reverse.
             */
            transitionDelay = (stepsBack - 1) * transitionSpeed;
            stepsBack -= 1;
          } else if (stage.percentageComplete > _this3.state.prevStages[index].percentageComplete) {
            /**
             * Load each transition sequentially.
             */
            transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
            stepsForward -= 1;
          }
        }
        return jsx(Stage, {
          transitionSpeed: transitionSpeed,
          transitionDelay: transitionDelay,
          transitionEasing: transitionEasing,
          key: stage.id,
          item: stage,
          render: _this3.props.render
        });
      });
      var listInlineStyles = (_listInlineStyles = {
        gridTemplateColumns: "repeat(".concat(items.length, ", 1fr)")
      }, _defineProperty(_listInlineStyles, varSpacing, spacing[this.props.spacing]), _defineProperty(_listInlineStyles, "maxWidth", 8 * 10 * items.length * 2), _listInlineStyles);
      return jsx("ul", {
        "data-testid": testId,
        style: listInlineStyles,
        css: containerStyles,
        "aria-label": label
      }, items);
    }
  }]);
  return ProgressTracker;
}(PureComponent);
_defineProperty(ProgressTracker, "defaultProps", {
  items: [],
  spacing: 'cosy',
  render: {
    link: function link(_ref) {
      var item = _ref.item;
      return jsx(Link, item);
    }
  },
  animated: true,
  label: 'Progress'
});
export { ProgressTracker as default };